import type { HeaderItem } from '../../../components/data-table';
import type { StatisticsTable } from './types';

export const tableHeaders: HeaderItem<StatisticsTable>[] = [
  { id: 'id', title: 'ID' },
  { id: 'manager', title: 'МЕНЕДЖЕРИ Події' },
  { id: 'count', title: 'Назначено контактів' }
];
